<style>
.hello {
  height: 600px !important;
  margin-top: 20px;
}
</style>

<template>
  <div style="padding:30px;background-color:#fff">
    <div>
      <b
        ><h3>{{ title }}</h3></b
      >
    </div>
    <br />
    <v-layout>
      <v-toolbar style="box-shadow:none;background-color:#fff">
        <v-layout>
          <!-- <v-row>
            <v-col cols="2">
              <v-text-field
                v-model="request_no"
                label="Request Number"
              ></v-text-field>
            </v-col>

            <v-col cols="2">
              <v-autocomplete
                item-text="NAME"
                item-value="USER_ID"
                v-model="cataloguer"
                :items="list_cataloguer"
                label="Choose Cataloguer"
              ></v-autocomplete>
            </v-col>

            <v-col cols="2">
              <v-select
                item-text="name"
                item-value="id"
                v-model="month"
                :items="list_month"
                label="Choose Month"
              ></v-select>
            </v-col>

            <v-col cols="2">
              <v-select
                item-text="plant_name"
                item-value="plant_code"
                v-model="plant"
                :items="list_plant"
                label="Choose Plant"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <div>
                <v-btn color="primary" depressed v-on:click="getData">
                  Search
                </v-btn>

                <v-btn
                  class="ml-2"
                  color="success"
                  depressed
                  dark
                  v-on:click="reset"
                >
                  Clear Filter
                </v-btn>

                <v-progress-circular
                  indeterminate
                  class="ml-2"
                  color="primary"
                  v-if="loading"
                ></v-progress-circular>
              </div>
            </v-col>
          </v-row> -->
          <v-row>
            <v-row>
              <v-col cols="7">
                <v-btn
                  color="primary"
                  depressed
                  v-on:click="form_search = true"
                >
                  Filter
                </v-btn>

                <v-btn
                  class="ml-2"
                  color="success"
                  depressed
                  dark
                  v-on:click="reset"
                >
                  Clear Filter
                </v-btn>

                <v-btn
                  class="ml-2"
                  color="#1e6d42"
                  dark
                  :loading="loadingDownload"
                  v-on:click="exportData()"
                >
                  <v-icon dark style="margin-right:10px"
                    >mdi-microsoft-excel</v-icon
                  >
                  Export
                </v-btn>

                <v-progress-circular
                  indeterminate
                  class="ml-2"
                  color="primary"
                  v-if="loading"
                ></v-progress-circular>
              </v-col>

              <v-col>
                <div align="right" style="margin-top: -10px;">
                  <v-text-field
                    label=""
                    v-model="description"
                    placeholder="Enter your description"
                    solo
                    v-on:keyup.enter="getData()"
                    append-icon="search"
                    @click:append="getData()"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-row>
        </v-layout>
      </v-toolbar>
    </v-layout>

    <div class="mt-5">
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-options': [10, 25],
        }"
        :no-data-text="loading ? 'Loading Data' : 'No Data Available'"
      >
        <template>123</template>

        <template v-slot:item.message="{ item }">
          <v-card
            flat
            v-for="(data, index) of item.feedback"
            :key="index"
            class="mb-2 mt-2"
            style="border: 1px solid #ECEFF1;"
          >
            <v-card-text class="pa-1 px-3">
              <div
                style="font-weight: 600; display: flex; align-items: center;"
              >
                {{ data.name }}
                <v-btn
                  depressed
                  rounded
                  x-small
                  color="#0097a7"
                  dark
                  class="ml-1"
                >
                  <span v-if="data.role_id === 'REQ'">Requester</span>
                  <span v-if="data.role_id === 'APP1'">Approver</span>
                  <span v-if="data.role_id === 'CAT'">Cataloguer</span>
                  <span v-if="data.role_id === 'ADM'">Administrator</span>
                  <span v-if="data.role_id === 'PROC'">Procurement</span>
                </v-btn>
              </div>
              <div class="mt-1">{{ data.message }}</div>
              <div style="font-weight: bold; font-size: 12px">
                {{ data.input_date }}
              </div>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="form_search" max-width="700px">
      <v-card>
        <v-card-title> Filter List </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <div>
                <label>Request Number</label>
                <v-text-field
                  v-model="request_no"
                  label="Request Number"
                  solo
                  hide-details
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="6">
              <div>
                <label>Material Number</label>
                <v-text-field
                  v-model="material_number"
                  label="Material Number"
                  solo
                  hide-details
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="6">
              <div>
                <label>Cataloguer</label>
                <v-autocomplete
                  item-text="NAME"
                  item-value="USER_ID"
                  v-model="cataloguer"
                  :items="list_cataloguer"
                  label="Choose Cataloguer"
                  solo
                  hide-details
                ></v-autocomplete>
              </div>
            </v-col>
            <v-col cols="6">
              <div>
                <label>Month</label>
                <v-select
                  item-text="name"
                  item-value="id"
                  v-model="month"
                  :items="list_month"
                  label="Choose Month"
                  solo
                  hide-details
                ></v-select>
              </div>
            </v-col>
            <v-col cols="6">
              <div>
                <label>Plant</label>
                <v-select
                  item-text="plant_name"
                  item-value="plant_code"
                  v-model="plant"
                  :items="list_plant"
                  label="Choose Plant"
                  solo
                  hide-details
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <div class="mt-5" align="right">
            <v-btn rounded depressed class="mr-2" @click="form_search = false">
              Close
            </v-btn>

            <v-btn
              color="primary"
              rounded
              depressed
              :loading="loading"
              v-on:click="getData()"
            >
              Filter
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment"

export default {
  methods: {
    async getData() {
      var self = this
      var url = self.base_url + "material/feedback/log"
      self.loading = true
      self.form_search = false

      var data = {
        request_no: self.request_no,
        cataloguer: self.cataloguer,
        month: self.month,
        plant: self.plant,
        role: self.storage_role,
        user_id: self.storage_user_id,
        material_number: self.material_number,
        description: self.description,
      }

      if (self.storage_role === "REQ") {
        data.requester = self.storage_user_id
      }

      try {
        const response = await self.axios.post(url, data)
        self.data = response.data
        self.loading = false
      } catch (err) {
        self.loading = false
        alert(err)
      }
    },
    exportData() {
      var self = this
      var url = self.base_url + "material/feedback/export"

      var data = {
        request_no: self.request_no,
        cataloguer: self.cataloguer,
        month: self.month,
        plant: self.plant,
        role: self.storage_role,
        user_id: self.storage_user_id,
        material_number: self.material_number,
        description: self.description,
      }

      var responseType = {
        responseType: "arraybuffer",
      }

      self.loadingDownload = true

      self.axios.post(url, data, responseType).then(function(response) {
        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", "log_feedback.xlsx")
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        self.loadingDownload = false
      })
    },
    reset() {
      var self = this
      self.plant = ""
      self.month = ""
      self.cataloguer = ""
      self.request_no = ""
      self.material_number = ""

      this.getData()
    },

    getPlant() {
      var self = this
      var url = self.base_url + "master/dropdown/attribute/plant/plant_code"
      self.axios.get(url).then(function(response) {
        self.list_plant = response.data
      })
    },

    getCataloguer() {
      var self = this
      var url = self.base_url + "master/dropdown/user_cataloguer"
      self.axios.get(url).then(function(response) {
        self.list_cataloguer = response.data
      })
    },

    getDateMonth() {
      this.date = moment()
        .startOf("month")
        .format("YYYY-MM-DD")
      this.date2 = moment()
        .endOf("month")
        .format("YYYY-MM-DD")
    },

    formSearch() {
      this.form_search = true
    },
  },
  mounted() {
    if (
      this.storage_role != "CAT" &&
      this.storage_role != "ADM" &&
      this.storage_role != "APP1" &&
      this.storage_role != "REQ"
    ) {
      this.$router.push("/login")
    }

    // this.getDateMonth()
    this.getData()
    this.getPlant()
    this.getCataloguer()
  },
  data() {
    return {
      name: "LogFeedback",
      title: "Log Feedback",
      loading: false,
      loadingDownload: false,
      date: "",
      date2: "",
      data: [],
      list_plant: [],
      list_cataloguer: [],
      plant: "",
      month: "",
      cataloguer: "",
      request_no: "",
      material_number: "",
      description: "",
      form_search: false,
      param_search: "",
      menu: false,
      menu2: false,
      headers: [
        { text: "Request Number", value: "request_no", width: 150 },
        { text: "Material Number", value: "material_number", width: 150 },
        { text: "Description", value: "description", width: 200 },
        { text: "Requester", value: "request_by", width: 150 },
        { text: "Cataloguer", value: "cataloguer", width: 150 },
        { text: "Plant", value: "plant_name", width: 130 },
        { text: "Submit Date", value: "submit_date", width: 130 },
        { text: "Message", value: "message", width: 350 },
      ],
      list_month: [
        {
          id: "01",
          name: "January",
        },
        {
          id: "02",
          name: "February",
        },
        {
          id: "03",
          name: "March",
        },
        {
          id: "04",
          name: "April",
        },
        {
          id: "05",
          name: "May",
        },
        {
          id: "06",
          name: "June",
        },
        {
          id: "07",
          name: "July",
        },
        {
          id: "08",
          name: "August",
        },
        {
          id: "09",
          name: "September",
        },
        {
          id: "10",
          name: "October",
        },
        {
          id: "11",
          name: "November",
        },
        {
          id: "12",
          name: "December",
        },
      ],

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
    }
  },
}
</script>
